import axios from 'axios';
import {mapKeys, mapValues, snakeCase} from 'lodash';
import Errors from '../Errors';

export default {
    props: {
        nonce: {
            type: String,
            required: true,
        },
    },
    data: () => ({
        loading: false,
        submitted: false,
        errors: new Errors(),
    }),
    methods: {
        /**
         * @param {string} action
         * @param {object|FormData} data
         * @param {AxiosRequestConfig} config
         * @return {Promise<AxiosResponse<any>>}
         */
        request(action, data, config = null) {
            data.nonce = this.nonce;
            this.loading = true;
            this.errors.clear();
            return axios.post(`${window.GrandsEspaces.adminUrl}?action=${action}`, data, config)
                .then(response => {
                    this.loading = false;
                    this.submitted = true;
                    if (typeof this.reset === 'function') {
                        this.reset();
                    }
                    return response;
                })
                .catch(error => {
                    if (error.response.status === 400) {
                        this.errors.record(error.response.data.errors);
                    }
                    this.loading = false;
                    return error;
                });
        },
        /**
         * Map fields name to snake_case and transform boolean values to number
         * @param {Object|Array} fields
         *
         * @return {Object|Array}
         */
        mapFields(fields) {
            fields = mapKeys(fields, (value, key) => typeof key === 'string' ? snakeCase(key) : key);

            return mapValues(fields, value => {
                if (typeof value === 'boolean') {
                    value = Number(value);
                } else if (typeof value === 'object') {
                    value = this.mapFields(value);
                }

                return value;
            });
        },
    },
};


// WEBPACK FOOTER //
// ./assets/js/mixins/ajaxForm.js